import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-border bg-background" data-id="element-121">
      <div className="max-w-6xl mx-auto text-center" data-id="element-122">
        <div className="text-2xl font-bold text-white mb-4" data-id="element-123">
          🤖 SABER-DIGITAL™
        </div>
        <p className="text-muted max-w-md mx-auto mb-8" data-id="element-124">
          El sistema de aprendizaje e implementación de IA N°1 para el mundo
          hispanohablante.
          <br data-id="element-125" />
          <br data-id="element-126" />
          Porque dominar la Inteligencia Artificial no debería costarte años de
          prueba y error.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-12" data-id="element-127">
          <a href="mailto:soportesaberdigital0@gmail.com" className="hover:text-brand transition-colors" data-id="element-128">
            📧 soportesaberdigital0@gmail.com
          </a>
          <a href="https://www.instagram.com/saberdigital" target="_blank" rel="noopener noreferrer" className="hover:text-brand transition-colors" data-id="element-129">
            📲 @saberdigital
          </a>
          <a href="https://www.soportesaberdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-brand transition-colors" data-id="element-130">
            🌐 www.soportesaberdigital.com
          </a>
        </div>

        <div className="text-xs text-gray-600 mb-8" data-id="element-131">
          © SABER-DIGITAL™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>

        <div className="text-brand/50 font-heading italic mb-8" data-id="element-132">
          🤖 "El próximo lunes puede ser diferente."
        </div>

        <div className="text-xs text-gray-700 max-w-2xl mx-auto text-left bg-surface p-4 rounded-lg" data-id="element-133">
          ✅ CARTA DE VENTAS COMPLETA — SABER-DIGITAL™
          <br data-id="element-134" />
          Escribe FUNNEL para generar:
          <br data-id="element-135" />
          📧 Secuencia de emails de lanzamiento (5 emails)
          <br data-id="element-136" />
          📱 Copy para anuncios de Meta/TikTok
          <br data-id="element-137" />
          🎥 Script de VSL (Video Sales Letter)
        </div>
      </div>
    </footer>;
}